import classNames from 'classnames';

import styles from './styles.module.css';

const VerticalBarGraph = ({ values = [], selectedIndex, label = '', direction = 'column' }) => {
    const cellClassNames = (index) =>
        classNames(styles.cell, {
            [styles.selectedCell]: index == selectedIndex,
        });

    return (
        <div className={styles.root} style={{ flexDirection: direction }}>
            <div className={styles.label}>{label}</div>
            {values.map((v, i) => (
                <div
                    key={i}
                    style={{ backgroundColor: v.backgroundColor || 'white', color: v.color || 'black' }}
                    className={cellClassNames(i)}
                >
                    {v.value}
                </div>
            ))}
        </div>
    );
};

export default VerticalBarGraph;
